export interface DynamicAppIconRegistry {
  IconName: string;
}
